define([
  'react',
  'prop-types',
  'react-transition-group',
  'underscore',
  'immutable',
  'es6!sumo/util',
  'es6!launcher/util/listbuilder/constants',
], (React, PropTypes, ReactTransitionGroup, _, Immutable, Util, Constants) => {
  const { CSSTransitionGroup } = ReactTransitionGroup;
  const { classNames } = Util;

  return (Component) => {
    class PopupAnimation extends React.Component {
      static propTypes = {
        animation: PropTypes.instanceOf(Immutable),
        formType: PropTypes.string.isRequired,
      }

      static defaultProps = {
        animation: Immutable.Map(),
      };

      renderAnimationStyle() {
        const { animation } = this.props;
        const animationSlug = animation.get('slug');
        const animationCss = animation.get('css') || '';
        // If the animation is shake, we won't have css to render.
        if (animationSlug !== 'shake' && !animationCss.length) return;

        // .sumome-vex.sumome-popup .sumome-popup-content.sumome-animated-flip
        const css = animationCss.replace(
          '.sumome-vex.sumome-popup .sumome-popup-content.',
          '.sumome-animated.',
        );

        return <style dangerouslySetInnerHTML={{ __html: css }} />; // eslint-disable-line
      }

      renderTransitionGroup() {
        const { animation } = this.props;
        const animationSlug = animation.get('slug');
        const animationDuration = animation.get('duration');
        const animationClassName = `sumome-animated-${animationSlug}`;
        const propsCopy = _.clone(this.props);

        propsCopy.className = classNames(propsCopy.className || '', {
          [animationClassName]: true,
        });

        return (
          <CSSTransitionGroup
            transitionName={{
              appear: 'sumome-animated',
              appearActive: animationClassName,
              enter: 'sumome-animated',
              enterActive: animationClassName,
            }}
            transitionAppearTimeout={animationDuration}
            transitionEnterTimeout={animationDuration}
            transitionAppear={!!animationSlug}
            transitionEnter={!!animationSlug}
            transitionLeave={false}
          >
            <Component key={animationSlug} {...propsCopy} />
          </CSSTransitionGroup>
        );
      }

      render() {
        const { formType, goal } = this.props;
        const formTypes = [
          Constants.FormTypes.SCROLL_BOX,
          Constants.FormTypes.INLINE_POPUP,
          Constants.FormTypes.SMART_BAR,
        ];

        if (
          (formTypes.indexOf(formType) > -1)
            || (goal === Constants.FormGoals.SOCIAL_PROOF && formType === Constants.FormTypes.POPUP)
        ) {
          // No animations when popup is embedded
          return (
            <Component
              {...this.props}
            />
          );
        }

        // We give the CSSTransitionGroup the animationSlug as a key so
        // when animationSlug changes, we get the new animation. Key changes
        // cause a rerender.
        return (
          <div className="sumome-react-wysiwyg-popup-animation-group">
            {this.renderAnimationStyle()}
            {this.renderTransitionGroup()}
          </div>
        );
      }
    }

    return PopupAnimation;
  };
});
